// Vendors
import Vue from 'vue';
import Slick from 'vue-slick';

// Global components
import ProductItem from './components/product-item.js';
import MaCode from './components/ma-code.vue';
import BackToTop from './components/back-to-top.vue';

// Template specific components
import Collection from './components/collection.js';
import Product from './components/product.js';
import ProductRelated from './components/product-related.js';
import CustomerAddresses from './components/customer-addresses.js';
import CustomerLogin from './components/customer-login.js';
import Cart from './components/cart-template.js';
import Accordion from './components/accordion.vue';
import Collapsible from './components/collapsible.vue';
import Tabs from './components/tabs.vue';
import Tab from './components/tab.vue';
import ReadMore from './components/read-more.vue';
import BrandsListing from './components/brands-listing';
import BookingForm from './components/booking-form';
import Faq from './components/faq';
import BlogSidebar from './components/blog-sidebar';
import CustomerRegister from './components/customer-register.js'
import CustomerRegistrationForm from './components/customer-registration-form.js'
import FooterNewsletterForm from './components/footer-newsletter-form.js'
import CountdownTimer from './components/countdown-timer.vue';

function initVueInstance(element) {
    new Vue({
        el: element,

        delimiters: ['${', '}'],

        components: {
            Slick,

            ProductItem,
            MaCode,
            BackToTop,

            Collection,
            Product,
            ProductRelated,
            CustomerAddresses,
            CustomerLogin,
            Cart,
            Accordion,
            Collapsible,
            Tabs,
            Tab,
            ReadMore,
            BrandsListing,
            BookingForm,
            BlogSidebar,
            CustomerRegister,
            CustomerRegistrationForm,
            FooterNewsletterForm,
            Faq,
            CountdownTimer
        }
    });
}

document.querySelectorAll('[vue-init]').forEach(element => {
    initVueInstance(element);
});